import { env } from '@ria-client/env';
import { getGraphQLClient } from '.';
import { GraphQLClientError } from './errors';
import type { QueryOrMutation, Variables } from './types';

export const getSupergraphUrl = () => {
  const prefix = env.NEXT_PUBLIC_NW_URL;
  return `${prefix}/api/supergraph`;
};

function isMutation(query: QueryOrMutation): boolean {
  if (typeof query === 'string') {
    return query.startsWith('mutation');
  } else {
    const firstDefinition = query.definitions[0];
    if (firstDefinition?.kind === 'OperationDefinition') {
      return firstDefinition.name?.value === 'mutation';
    }
  }

  return false;
}

function handleGraphQlErrors(err: unknown) {
  if (err instanceof GraphQLClientError) {
    throw err;
  } else {
    throw new Error(`GraphQlRequest error. ${err instanceof Error ? err.message : ''}`, {
      cause: err instanceof Error ? err : undefined,
    });
  }
}

export const graphQlRequest = async <T extends Record<string, unknown> = Record<string, unknown>>(
  query: QueryOrMutation,
  variables: Variables = {},
  clientToUse = getGraphQLClient(),
  fetchPolicy: RequestCache = 'force-cache',
  signal?: AbortSignal,
): Promise<T | null> => {
  try {
    let response: { data?: T | null | undefined };
    if (isMutation(query)) {
      response = await clientToUse.mutation<T>(query, variables, {
        ...(signal && { signal }),
      });
    } else {
      response = await clientToUse.query<T>(query, variables, {
        cache: fetchPolicy,
        ...(signal && { signal }),
      });
    }

    return response.data ?? null;
  } catch (err) {
    handleGraphQlErrors(err);
    return null;
  }
};
